import React from "react";

const BoxSkeleton = ({ ...props }) => {
  const { height, width } = props;
  return (
    <div
      className={`${height} ${width ?? "w-full"} rounded-md bg-gray-300`}
    ></div>
  );
};

export default BoxSkeleton;
